import React, { Fragment, useEffect, useState } from 'react';
import { ErrorNotification } from '../ErrorNotification';
import { Popup } from '../Popup';
import { Message } from './Message';
import { observer } from 'mobx-react';
import { Checkbox } from '../Checkbox';

interface IMessageComponentProps {
  message: Message | undefined;
  clearCallback: () => void;
}

export const MessageComponent = observer((props: IMessageComponentProps) => {

  const message = props.message;

  if (message && message.visible) {
    return (
      <Fragment>
        {message.messageType === 'notification' ? (
          <ErrorNotification
            type={message.messageSeverity}
            message={message.messageContent}
            hidden={!message.visible}
            header={message.messageTitle}
            infoUrl={message.infoUrl}
            shortErrorCode={message.shortErrorCode}
            fullErrorCode={message.fullErrorCode}
            timestamp={message.timestamp}
            clear={message.buttonArray.find((button) => button.cancelSharesCallback) ? message.buttonArray.find((button) => button.cancelSharesCallback)?.callback : props.clearCallback}
          >
            {message.buttonArray && message.buttonArray.length > 0
              ? message.buttonArray.map((value, index) => {
                if (value.value !== undefined && value.type && value.type === 1 && (message.messageSeverity === 'default' && message.canMute && message.hasLocalMuteToggle)) {
                  return (
                    <div key={`notification-checkbox-${index}`} className='usa-checkbox'>
                      <input
                        type='checkbox'
                        className='usa-checkbox__input'
                        id="notification-mute-toggle-local"
                        name="notification-mute-toggle-local"
                        data-testid="the-Checkbox"
                        onChange={value.callback}
                      />
                      <label htmlFor='notification-mute-toggle-local' className='usa-checkbox__label align-items-center'>{value.text}</label>
                    </div>
                  )
                }
                else return (
                  <button key={`notification-button-${index}`} className="usa-button usa-button--outline" type="button" onClick={value.callback}>
                    {value.text}
                  </button>
                );
              })
              : null}

            {message.messageSeverity === 'default' && message.canMute && !message.hasLocalMuteToggle ?
              <Checkbox
                label="Don't show this again"
                id="notification-mute-toggle"
                name="notification-mute-toggle"
                checked={message.muted}
                onChange={message.toggleMuteNotification}
              />
              : null}
          </ErrorNotification>
        ) : (
          <Popup
            title={message.messageTitle}
            trigger={message.visible}
            setTrigger={props.clearCallback}
            children={message.messageContent}
          />
        )}
      </Fragment>
    )
  }
  else return null;
});